export enum ResourceType {
    User = 0,
    Field = 1,
    Implement = 2,
    Vehicle = 3,
    Product = 4,
    Operation = 5,
    Job = 6,
    Timesheet = 7,
}